import { AppState } from '../root-reducer';

export const selectHighlightedSearchPosition = (state: AppState) => state.searchDomain.highlightedPosition;

export const selectActiveSearchPosition = (state: AppState) => state.searchDomain.activePosition;
